import React, { useState, useEffect } from "react";
import "./SI180Dashboard.css";
import { Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import LeftNav from "./LeftNav";
import { fetchCustomer } from "../../services/api/si180Api";
import { setLoading } from "../../redux/publicReducer/actions";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const primColor = process.env.REACT_APP_SI180_PRIMCOLOR;
const textColor = process.env.REACT_APP_TEXT_COLOR;
const btnColor = process.env.REACT_APP_SI180_BTNCOLOR;
const greyColor = process.env.REACT_APP_SI180_BGGREY;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const secColor = process.env.REACT_APP_SI180_SECCOLOR;

const SI180Dashboard = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(15);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCustomer(searchTerm);
        setUsers(data.length > 0 ? data : []);
        if (data.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No record found.",
          });
        }
        dispatch(setLoading(false));
      } catch (error) {
        console.error("fetchCustomer failed:", error);
      }
    };

    fetchData();
  }, [searchTerm, dispatch]);

  // const selectedCustomer = (customerNumber) => {
  //   sessionStorage.setItem("selectedCustomer", customerNumber);
  //   history.push("/resident-menu");
  // };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const currentUser = {
    firstName: JSON.parse(sessionStorage.getItem("currentUser"))[0].FirstName,
    lastName: JSON.parse(sessionStorage.getItem("currentUser"))[0].LastName,
  };

  const selectedCustomer = (user) => {
    Swal.fire({
      title: `<h5>You selected</h5>${user.FirstName} ${user.LastName}`,
      html: `<h5>Please confirm your selection.</h5>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: btnColor,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed!",
      customClass: {
        confirmButton: "swal-wide swal-button-font",
        cancelButton: "swal-wide swal-button-font",
      },
    }).then((result) => {
      if (result.value) {
        sessionStorage.setItem("selectedCustomer", JSON.stringify(user));
        history.push("/resident-menu");
      }
    });
  };

  return (
    <div className="dashboard">
      <LeftNav />
      <div className="right-pane" style={{ backgroundColor: greyColor }}>
        <div className="si180header">
          <div className="welcome">
            <Typography
              style={{
                textAlign: "center",
                // marginRight: "1rem",
                lineHeight: "1.2",
              }}
              variant={"h6"}
            >
              Welcome,{" "}
              <span
                style={{
                  color: primColor,
                }}
              >
                {currentUser.firstName} {currentUser.lastName}
              </span>
              !
            </Typography>
          </div>
          <div className="si180Search">
            <input
              className="si180btn"
              type="text"
              placeholder="Search..."
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Customer Number</th>
              <th>First Name</th>
              <th>Last Name</th>
            </tr>
          </thead>
          <tbody>
            {users
              .slice(
                (currentPage - 1) * usersPerPage,
                currentPage * usersPerPage
              )
              .map((user) => (
                <tr
                  key={user.CustomerNumber}
                  onClick={() => selectedCustomer(user)}
                  style={{
                    cursor: "pointer",
                  }}
                  className="tr-hover"
                >
                  <td>{user.CustomerNumber}</td>
                  <td>{user.FirstName}</td>
                  <td>{user.LastName}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <Pagination
          count={Math.ceil(users.length / usersPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          style={{ marginTop: 20, justifyContent: "center", display: "flex" }}
        />
      </div>
    </div>
  );
};

export default SI180Dashboard;
